<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.changeOrderStatus === 'D' || row.changeOrderStatus === 'R'
              ? 'warning'
              : row.changeOrderStatus === 'N'
              ? 'primary'
              : 'success'
          "
        >
          {{ row.v_changeOrderStatus }}
        </el-tag>
      </template>
      <template v-slot:oldOrderAmountInfo="{ row }">
        <span> {{ row.v_oldOrderAmount }} {{ row.v_oldCurrencyUnit }}</span>
      </template>
      <template v-slot:newOrderAmountInfo="{ row }">
        <span> {{ row.v_newOrderAmount }} {{ row.v_newCurrencyUnit }}</span>
      </template>
      <template v-slot:oldOrderSalesAmountInfo="{ row }">
        <span>
          {{ row.v_oldOrderSalesAmount }} {{ row.v_oldSalesCurrencyUnit }}</span
        >
      </template>
      <template v-slot:newOrderSalesAmountInfo="{ row }">
        <span>
          {{ row.v_newOrderSalesAmount }} {{ row.v_newSalesCurrencyUnit }}</span
        >
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { code: row.changeOrderCode },
                  query: { changeOrderNo: row.changeOrderNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
            v-show="
              row.changeOrderStatus === 'N' || row.changeOrderStatus === 'R'
            "
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: { code: row.changeOrderCode },
                  query: { changeOrderNo: row.changeOrderNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="allow('D')"
            v-show="
              row.changeOrderStatus === 'N' || row.changeOrderStatus === 'R'
            "
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.changeOrderCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_submit_review') || '提交审核'"
            placement="top"
            v-if="allow('T')"
            v-show="
              row.changeOrderStatus === 'N' || row.changeOrderStatus === 'R'
            "
          >
            <i class="el-icon-position tool-btn" @click="submit(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'order-changeOrderDetail',
        params: { ...params, pageType },
        query,
      })
    },

    submit(row) {
      this.$confirm(
        this.$l('INDEX.tips_question_submitAudit') || '是否要提交审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.loadingOpen()
          this.$api
            .changeOrderSubmitApi({
              changeOrderCode: row.changeOrderCode,
              orderCode: row.orderCode,
            })
            .then((res) => {
              this.loadingClose()
              const { status } = res
              if (status == 200) {
                this.$message({
                  message:
                    this.$l('INDEX.tips_Submitted_successfully') ||
                    '提交成功！',
                  type: 'success',
                })
                this.$emit('reload')
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                })
              }
            })
            .catch(() => {
              this.loadingClose()
            })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    // del(code) {
    //   this.$confirm(
    //     this.$l('INDEX.tips_delete') || '是否要删除该记录？',
    //     this.$l('INDEX.label_completeDesc') || '确认信息',
    //     {
    //       confirmButtonText:
    //         this.$l('INDEX.product_dialog_btn_confirm') || '确定',
    //       cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
    //       type: 'warning',
    //     }
    //   ).then(() => {
    //     this.$api.changeOrderDelApi({changeOrderCode: code}).then(() => {
    //       this.$message({
    //         showClose: true,
    //         message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
    //         type: 'success',
    //       })
    //       this.$emit('reload')
    //     })
    //   })
    // },
  },
}
</script>
